import { ArrowLeftRight } from "lucide-react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { QuoteComparison } from "@/components/admin/QuoteComparison";

/** Every quote this customer has had, oldest first, for fee tracking. */
export const QuoteComparisonDialog = ({ lead, onClose }) => (
  <Dialog open={!!lead} onOpenChange={(open) => !open && onClose()}>
    <DialogContent
      data-testid="quote-comparison-dialog"
      className="max-h-[90vh] overflow-y-auto bg-white sm:max-w-3xl lg:max-w-5xl"
    >
      <DialogHeader className="text-left">
        <DialogTitle className="flex items-center gap-2 pr-8 text-lg">
          <ArrowLeftRight className="h-5 w-5 shrink-0 text-primary" aria-hidden="true" />
          {lead?.full_name}&apos;s quotes, side by side
        </DialogTitle>
        <DialogDescription>
          Oldest first, with what each fee did since their previous quote for the same service.
        </DialogDescription>
      </DialogHeader>
      {lead ? <QuoteComparison quoteRef={lead.quote_ref} /> : null}
    </DialogContent>
  </Dialog>
);
